import { routeUrls } from '../app/Routing/RouteUrls';
import { DianaFeaturesEnum, useEnvironment, useFeatures } from '@diana/core';
import { useMemo } from 'react';
import { useNavMenuItems } from './useNavMenuItems';

export function useBreadcrumbsRoot(forPage: 'work' | 'performance' | 'people' | 'assets' | 'home') {
  const environment = useEnvironment();
  const { getNavMenuLabel } = useNavMenuItems();
  const assets = useAssetsBreadcrumbsRoot();
  const roots = useMemo(
    () => ({
      home: {
        title: getNavMenuLabel('home'),
        link: routeUrls.home.url({ environment }, {}),
      },
      work: {
        title: getNavMenuLabel('work'),
        link: routeUrls.workflows.url({ environment }, {}),
      },
      performance: {
        title: getNavMenuLabel('performance'),
        link: routeUrls.performance.url({ environment }, null),
      },
      people: {
        title: getNavMenuLabel('people'),
        link: routeUrls.people.url({ environment }, null),
      },
      assets,
    }),
    [getNavMenuLabel, environment, assets],
  );
  return roots[forPage];
}

export function useAssetsBreadcrumbsRoot() {
  const environment = useEnvironment();
  const { getNavMenuLabel, isNavMenuHidden } = useNavMenuItems();
  const hasAssetPage = !isNavMenuHidden('assets');
  const hasToShowEntitiesOnWorkPage = !!useFeatures()[DianaFeaturesEnum.ShowAssetsOnWorkPage];
  if (!hasAssetPage && hasToShowEntitiesOnWorkPage) {
    return {
      title: getNavMenuLabel('work'),
      link: routeUrls.workflows.url({ environment }, {}),
    };
  }

  return {
    title: getNavMenuLabel('assets'),
    link: routeUrls.thingsGroups.url({ environment }, null),
  };
}
